import * as React from 'react';
import { Location } from 'cb-model';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

/**
 * Location Search Page
 *
 * Search and list all locations for the user's institution
 */
export const LocationSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'name', operator: 'ct', value: '' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(Location, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(Location, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={Location} />
      <Section>
        <IsAllowed entity={Location} action="create">
          <Link to="/admin/location/create">
            <Button size="sm" variant="primary">
              Create a new Location
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={Location}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
